"use client";

import { Icon as OfflineIcon } from "@iconify/react/dist/offline";
import type { IconProps as OfflineIconProps } from "@iconify/react/dist/offline";
import { ICON_REGISTRY } from "@/components/ui/icon-registry.generated";

type IconProps = Omit<OfflineIconProps, "icon"> & {
  icon: string;
};

const warnedIcons = new Set<string>();

export function Icon({ icon, ...props }: IconProps) {
  const iconData = ICON_REGISTRY[icon];

  if (!iconData) {
    if (process.env.NODE_ENV !== "production" && !warnedIcons.has(icon)) {
      warnedIcons.add(icon);
      console.warn(
        `[Icon] Missing local icon "${icon}". Run "node scripts/generate-icon-registry.mjs".`,
      );
    }
    return null;
  }

  return <OfflineIcon icon={iconData} {...props} />;
}
